import { createEmitter } from "ts_utils";
import { Templates } from "../ui/Templates";

export interface PublicCommunityLIData {
	communityId:number;
	name:string;
	publicDescription:string;
	publicAges:string;
}

export class PublicCommunityLI {
	public data:PublicCommunityLIData;
	public ui:HTMLLIElement;
	
	private _communityLI:HTMLDivElement;
	private _titleDiv:HTMLDivElement;
	private _descriptionDiv:HTMLDivElement;
	private _agesDiv:HTMLDivElement;
	private _joinDiv:HTMLDivElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<PublicCommunityLIEvent>();
	
	constructor(data:PublicCommunityLIData){
		this.data = data;
		
		this._init();
	}
	
	public showJoinDiv():void {
		this._communityLI.classList.add("showJoin");
	}
	
	public hideJoinDiv():void {
		this._communityLI.classList.remove("showJoin");
	}
	
	public showGuestVisitDiv():void {
		this._joinDiv.innerHTML = "Visit";
		this.showJoinDiv();
	}
	
	private _init():void {
		this.ui = Templates.createElement(communityLITemplate) as
			HTMLLIElement;
		this._communityLI = this.ui.querySelector(".stscr-communityLI");
		this._titleDiv = this.ui.querySelector(".stscr-cli-title");
		this._descriptionDiv = this.ui.querySelector(".stscr-cli-description");
		this._agesDiv = this.ui.querySelector(".stscr-cli-ages");
		this._joinDiv = this.ui.querySelector(".stscr-cli-join");
		
		this._titleDiv.innerHTML += this.data.name;
		this._descriptionDiv.innerHTML += this.data.publicDescription;
		this._agesDiv.innerHTML += this.data.publicAges;
		
		this._joinDiv.addEventListener("click", this._onJoinClick);
	}
	
	private _onJoinClick = (e:MouseEvent) => {
		let ev = new PublicCommunityLIEvent();
		ev.type = PublicCommunityLIEventType.joinRequest;
		ev.target = this;
		this._emitter.emit(ev);
	}
}

export class PublicCommunityLIEvent {
	public type:PublicCommunityLIEventType;
	public target:PublicCommunityLI;
}

export enum PublicCommunityLIEventType {
	joinRequest
}

const communityLITemplate = `
<li class="splide__slide">
	<div class="stscr-communityLI">
		<div class="stscr-cli-top">
			<div class="stscr-cli-title"></div>
			<div class="stscr-cli-details">
				<div class="stscr-cli-description">
					<span>Description: </span>
				</div>
				<div class="stscr-cli-ages">
					<span>Ages: </span>
				</div>
			</div>
		</div>
		<div class="stscr-cli-bottom">
			<div class="stscr-cli-join">Join</div>
		</div>
	</div>
</li>
`;